import * as React from 'react';
import { loadingScheduler } from '../../../services/loading-scheduler';
import { fedopsLogger } from '../../../services/fedopsLogger';

export class LazyChatRoomScreen extends React.Component<any> {
  ChatRoomScreen;
  Branding;
  mounted = false;

  componentDidMount() {
    this.mounted = true;

    void loadingScheduler.onInteractive().then(async () => {
      fedopsLogger.interactionStarted('loading-interactivity-chunk');
      this.ChatRoomScreen = (
        await import(
          /* webpackChunkName: "chat-interactivity" */ '@wix/chat-web'
        )
      ).ChatRoomScreen;
      this.Branding = (
        await import(
          /* webpackChunkName: "chat-interactivity" */ '../../Branding/Branding'
        )
      ).default;
      fedopsLogger.interactionEnded('loading-interactivity-chunk');

      if (this.mounted) {
        this.forceUpdate();
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    return this.ChatRoomScreen ? (
      <this.ChatRoomScreen
        {...this.props}
        banner={this.props.banner === true ? <this.Branding /> : undefined}
      />
    ) : (
      <div />
    );
  }
}
